import type { KgInspectorIconKey } from "./kgInspectorIcons";
import type { InspectorTabConfig } from "./panelConfig";

export const ARTIFACTS_SECTION_ID = "artifacts";

export const DATA_STORY_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "trace", label: "Trace" },
  { id: "activity", label: "Activity" },
];

export const DATA_STORY_HEADER_ICON: KgInspectorIconKey = "dataStoryPanel";

export const DATA_STORY_TRACE_DEFAULT_EXPANDED: Record<string, boolean> = {
  dataSources: true,
};
